import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.whiteish,
  iconColor: colors.cerulean,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.onyx,
  textColorLight: colors.white
};
export default accordion;